import { defineStore } from "pinia";
import Services from '@/services/DeathCertificateServices'
import { mapDeathCertificate } from '@/helpers/mapFuncs'

export const useDeathCertificateStore = defineStore("deathCertificate", {

state:()=>({
    deathCertificate: {},
    deathCertificates: [],
}),
getters : {
    getDeathCertificate() {
        return mapDeathCertificate(this.deathCertificate)
    },
    getDeathCertificates() {
        return this.deathCertificates.map(mapDeathCertificate)
    }
},
actions : {
    /** Start Sets */
    setDeathCertificate(deathCertificate) {
        this.deathCertificate = deathCertificate
    },
    setDeathCertificates(deathCertificates) {
        this.deathCertificates = deathCertificates
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setDeathCertificate(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setDeathCertificate(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setDeathCertificates(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.deathCertificates.push(response.data.data)
            return mapDeathCertificate(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.deathCertificates[this.deathCertificates.findIndex((x)=>x.id == id)] = response.data.data
            return mapDeathCertificate(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.deathCertificates = this.deathCertificates.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});